import React from 'react'
import PageContainer from 'layout/default-sidebar-layout/PageContainer'
import { message } from 'antd'
import { autobind } from 'core-decorators'
import QAApi from 'api/QAApi'
import QAForm from '../form'
import Breadcrumb from '../breadcrumb'

@autobind
export default class QACreate extends React.PureComponent {
  async handleSubmit(data) {
     const res = await QAApi.createQA(data)
     if (res.success) {
       message.info('Register Q&A success!')
     }
     if (res.error) message.info(res.message)
  }

  render() {
    return (
      <PageContainer title="Create questions" {...this.props.wrapperProps}>
        <Breadcrumb items={['list', 'create']} />
        <QAForm onSubmit={this.handleSubmit}/>
        {/* <QAForm onSubmit={this.handleSubmit} /> */}
      </PageContainer>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/qa/create/index.js